import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-10">
      
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 lg:px-16 grid grid-cols-1 md:grid-cols-3 gap-10">

        {/* About Us */}
        <div>
          <h3 className="text-lg font-bold mb-4 text-gray-200">About Us</h3>

          <p className="text-sm text-gray-400 leading-6">
            We are a trusted consultancy firm committed to empowering businesses
            to reach their full potential. Our dedicated team provides
            innovative solutions tailored to your unique challenges, ensuring
            sustainable growth and success.
          </p>

          <p className="mt-4 text-sm text-gray-400">
            With years of expertise, we are your reliable partner in navigating
            the complexities of the modern business landscape.
          </p>
        </div>


        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-bold mb-4 text-gray-200">Quick Links</h3>

          <ul className="space-y-3">

            {[
              { href: "/services", label: "Services" },
              { href: "/about", label: "About Us" },
              { href: "/contact", label: "Contact" },
              { href: "/careers", label: "Careers" },
              { href: "/blog", label: "Blog" },
            ].map((link, index) => (

              <li key={index}>
                <a
                  href={link.href}
                  className="text-sm text-gray-400 hover:text-white transition duration-200"
                >
                  {link.label}
                </a>
              </li>

            ))}

          </ul>
        </div>


        {/* Contact */}
        <div>
          <h3 className="text-lg font-bold mb-4 text-gray-200">Contact Us</h3>

          <ul className="space-y-3 text-sm text-gray-400">

            <li>
              <span className="font-semibold text-gray-300">Phone:</span>{" "}
              +91 8090530570
            </li>

            <li>
              <span className="font-semibold text-gray-300">Email:</span>{" "}
              hr@corehiresolutions.in
            </li>

            <li>
              <span className="font-semibold text-gray-300">Address:</span>{" "}
              Gurgaon, Haryana
            </li>

          </ul>


          {/* Social Icons */}

          <div className="mt-6 flex space-x-4 text-lg">

            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>

            <a
              href="https://www.linkedin.com/company/alif-career-solutions/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-500 transition"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-pink-500 transition"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

          </div>
        </div>
      </div>


      {/* Footer Bottom */}

      <div className="text-center border-t border-gray-800 mt-8 pt-6 text-sm text-gray-500">

        <p>
          © {new Date().getFullYear()} CoreHire Solutions. All Rights Reserved.
        </p>

        <p>
          Designed with <span className="text-red-500">♥</span> by SHAURYA
          PANDEY
        </p>

      </div>
    </footer>
  );
};

export default Footer;